import routerOptions0 from "/root/injective/injective-helix/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@25.2.0_@vue+compiler-sfc@3.5.26_bufferutil_ddd4656572db2d8a2b1b53ea2b21717a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}